import MuiMenuItem from '@mui/material/MenuItem';
import type { AriaAttributes, ReactNode } from 'react';

export interface MenuItemProps extends Pick<AriaAttributes, 'aria-checked'> {
  onClick?: () => void;
  role?: string;
  // Visual tint only — assistive tech learns nothing from it. Pair with aria-checked.
  selected?: boolean;
  children?: ReactNode;
}

export function MenuItem({
  onClick,
  role,
  selected,
  children,
  // Which mode is active, for a menu picking one of a set. aria-selected is unsupported on a
  // menu item, so role="menuitemradio" + this is the only route; a ✓ glyph has no text alternative.
  ...aria
}: MenuItemProps) {
  return (
    <MuiMenuItem
      {...(onClick ? { onClick } : {})}
      {...(role !== undefined ? { role } : {})}
      {...(selected !== undefined ? { selected } : {})}
      {...aria}
    >
      {children}
    </MuiMenuItem>
  );
}
